import React from "react"


class SidebarNotifications extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
          }

    }
    componentWillMount(){
    }

    renderNotifications() {
        let self = this;
        return <ul>
                    {   
                        self.props.lst_notifications.map(function(msg, i) {
                                return (<li className="item" key={i}>
                                <ul>
                                    <li className="header regular">
                                        {msg.title}
                                        <i className="fa fa-times-circle remove clickable" onClick={self.props.handleNotification.bind(this,"remote","remove","",msg._id)}></i>
                                    </li>
                                    <li className="details">    
                                        <div className="datetime">
                                            <i className="clock"></i>
                                            <span className="days">today</span>
                                            <span className="time">{msg.datetime.$date.$numberLong}</span>
                                        </div>
                                        <div className="message">
                                            <p>{msg.msg}</p>
                                        <div className="progress">
                                            
                                            <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        </div>
                                    </li>
                        
                                </ul>
                        
                            </li>);
                            })
                    }
                </ul>   
    }

    renderNotificationsTmp() {
        let self = this;
        return <ul>
                    {   
                        this.props.lst_tmp_notifications.map(function(msg, i) {
                                return (<li className="item" key={i}>
                                <ul>
                                    <li className="header regular">
                                        {msg.title}
                                        <i className="fa fa-times-circle remove clickable" onClick={self.props.handleNotification.bind(this,"tmp","remove","",i)}></i>
                                    </li>
                                    <li className="details">
                                        <div className="datetime">
                                            <i className="clock"></i>
                                            <span className="days">{msg.day}</span>
                                            <span className="time">{msg.datetime}</span>
                                        </div>
                                        <div className="message">
                                            <p>{msg.msg} </p>
                                        <div className="progress">
                                            <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        </div>
                                    </li>
                        
                                </ul>
                        
                            </li>);
                            })
                    }
                </ul>   
    }

    render(){
        return(
            <div className={"sidebar-notifications " + this.props.app.state.status_sb_notifications}>
                    <div className="head-sidebar">
                        <div onClick={this.props.handleStatusNotifications.bind(this)} className="arrow-press">
                            <span className="arrow"></span>
                        </div>
                        <div className="header-title">NOTIFICATIONS</div>
                    </div>
                    <div className="list">
                        {this.renderNotificationsTmp()}
                    </div>
                    <div className="list">
                    
                        {this.renderNotifications()}
                    </div>
            </div>
        )}
}

export default SidebarNotifications


// WEBPACK FOOTER //
// ./src/Setup/components/SidebarNotifications.js